/**
 * Sentry configuration interface
 */
export interface SentryConfig {
  enabled: boolean;
  dsn: string;
  environment: string;
  release?: string;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
}

/**
 * Datadog configuration interface
 */
export interface DatadogConfig {
  enabled: boolean;
  clientToken: string;
  service: string;
  env: string;
  version?: string;
}

/**
 * Simplified context data type for monitoring services
 */
export type ContextData = Record<
  string,
  string | number | boolean | null | undefined
>;

/**
 * User information for monitoring services
 */
export type User = {
  id?: string;
  email?: string;
  username?: string;
};

/**
 * Get Sentry configuration from environment variables
 */
export function getSentryConfig(): SentryConfig {
  return {
    enabled: import.meta.env.FO_ENV !== "local",
    dsn: import.meta.env.VITE_SENTRY_DSN || "",
    environment: import.meta.env.FO_ENV,
    release: import.meta.env.APP_VERSION,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
  };
}

/**
 * Get Datadog configuration from environment variables
 */
export function getDatadogConfig(): DatadogConfig {
  return {
    enabled: import.meta.env.FO_ENV !== "local",
    clientToken: import.meta.env.DATADOG_CLIENT_TOKEN || "",
    service: "emr",
    env: import.meta.env.FO_ENV,
    version: import.meta.env.APP_VERSION,
  };
}

/**
 * Check if the application is running in development mode
 * Returns true for any non-production environment (local, staging, dev, etc.)
 */
export function isDevelopment(): boolean {
  return import.meta.env.FO_ENV !== "prod";
}
